import { ofType } from 'redux-observable';
import { filter, map } from 'rxjs/operators';
import { secondaryMarketBcsProductFetchRequestedUnlessLoadedThunk } from 'state/secondaryMarket/referential/bcsProduct/bcsProduct.thunks';
import type { EpicWithThunk } from 'state/state.common';

/** @todo probably change into a thunk */
export function loadActivatedRtFormTabEpic(): EpicWithThunk {
  return (actions$, _state$) => {
    return actions$.pipe(
      ofType('WORKSPACE_TAB_ACTIVATED'),
      filter(t => t.workspace === 'secondaryMarketQuotes' && t.tabType === 'realtimeQuote'),
      map(({ tabId }) => secondaryMarketBcsProductFetchRequestedUnlessLoadedThunk(tabId, 'realtimeQuote')),
    );
  };
}
